// extracted by mini-css-extract-plugin
export default {"HistoryList":"HistoryList--MI59v","formOperating":"formOperating--fnWnU"};